import type { RescheduleContextDto } from '@shared/core/reschedule'
import { formatInTimeZone } from 'date-fns-tz'
import type { RescheduleBlockedView } from './reschedule-blocked.interface'

export const RESCHEDULE_BLOCKED_DATE_TIME_FORMAT = 'iiii, MMMM d @ h:mmaaa'

/** Cutoff and start use the context's display zone, so the two lines never disagree. */
export function buildRescheduleBlockedView(
  context: RescheduleContextDto | null | undefined,
): RescheduleBlockedView | null {
  const eligibility = context?.eligibility
  if (!eligibility || eligibility.allowed !== false) return null
  const timezone = context.initialData?.timezone || 'UTC'
  const formatInstant = (iso: string | undefined) =>
    iso ? formatInTimeZone(iso, timezone, RESCHEDULE_BLOCKED_DATE_TIME_FORMAT) : null
  return {
    businessName: eligibility.business_name?.trim() || context.providerName,
    appointmentLabel: formatInstant(context.start_time_utc),
    cutoffLabel: formatInstant(eligibility.cutoff_at),
    policyText: eligibility.policy_text?.trim() ? eligibility.policy_text : null,
    confirmationUrlCode: eligibility.confirmation_url_code || null,
  }
}
